import React from 'react'
import { FaMotorcycle, FaBicycle, FaCar, FaTruck } from 'react-icons/fa'
import Container from './styles'

const RiderListItem = ({ rider }) => {
  const getInitials = () => {
    return `${rider.firstName?.[0] || ''}${rider.lastName?.[0] || ''}`
  }

  const getVehicleIcon = (vehicleType) => {
    switch (vehicleType) {
      case 'MOTORCYCLE':
        return <FaMotorcycle />
      case 'BICYCLE':
        return <FaBicycle />
      case 'CAR':
        return <FaCar />
      case 'VAN':
      case 'TRUCK':
        return <FaTruck />
      default:
        return <FaMotorcycle />
    }
  }

  const getVehicleBadgeClass = (vehicleType) => {
    switch (vehicleType) {
      case 'MOTORCYCLE':
        return 'motorcycle'
      case 'BICYCLE':
        return 'bicycle'
      case 'CAR':
        return 'car'
      case 'VAN':
      case 'TRUCK':
        return 'truck'
      default:
        return 'motorcycle'
    }
  }

  return (
    <Container>
      <div className="img--container">
        {getInitials()}
      </div>

      <h3>{rider.fullName || `${rider.firstName} ${rider.lastName}`}</h3>

      <p>{rider.phone}</p>

      <div className={`vehicle-badge ${getVehicleBadgeClass(rider.vehicleType)}`}>
        {getVehicleIcon(rider.vehicleType)}
        <span>{rider.vehicleType}</span>
      </div>
    </Container>
  )
}

export default RiderListItem
